import { render } from "./NoteInput.vue?vue&type=template&id=4f2e771e"
import script from "./NoteInput.vue?vue&type=script&lang=js"
export * from "./NoteInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__